import Pagination from "@mui/material/Pagination";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  page: number;
  totalItems: number;
  handleChangePage: (page: number) => void;
  defaultPageSize: number;
}

const CommonPagination = ({ page, handleChangePage, totalItems, defaultPageSize }: Props) => {
  const tRP = "components.pagination";
  const { t } = useTranslation();

  return (
    <Pagination
      page={page}
      count={totalItems ? Math.ceil(totalItems / defaultPageSize) : 0}
      onChange={(_, page) => handleChangePage(page)}
      siblingCount={0}
      getItemAriaLabel={(type, page, selected) => {
        switch (type) {
          case "first":
            return t("pagination.first");
          case "last":
            return t("pagination.last");
          case "next":
            return t("pagination.next");
          case "previous":
            return t("pagination.previous");
          case "page":
            return `${t("pagination.page", { page })}${selected ? t("pagination.current") : ""}`;
          default:
            return "";
        }
      }}
    />
  );
};

export default CommonPagination;
